module.exports = __webpack_public_path__ + "img/2p-en.0f40ca6c.png";